export const FETCH_ROLE = 'FETCH_ROLE';
export const FETCH_ALL_ROLE = 'FETCH_ALL_ROLE';
export const FILTER_ROLE = 'FILTER_ROLE';